import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryList: [],
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    addCategorytList: (state, action) => {
      state.categoryList = action.payload;
    },
    removeCategoryList: (state) => {
      state.categoryList = [];
    }
  },
});
export const {
  addCategorytList,
  removeCategoryList
} = categorySlice.actions;
export default categorySlice.reducer;
